export const SENDER_LIST_ATTRIBUTES_CONSTANT = {
  partner: {
    type: 'select',
    key: 'partner_id',
    label: 'Partner',
  },
  search: {
    type: 'text',
    key: 'search',
    label: 'Search',
    placeholder: 'id/name/mobile/email',
  },
} as const;
